
import { formatPrice, formatPriceCompact } from "@/utils/priceUtils";

interface PriceDisplayProps {
  price: number;
  compareAtPrice?: number | null;
  className?: string;
  compact?: boolean;
  showDiscount?: boolean;
}

const PriceDisplay = ({ 
  price, 
  compareAtPrice, 
  className = "", 
  compact = false,
  showDiscount = true 
}: PriceDisplayProps) => {
  const hasDiscount = compareAtPrice && compareAtPrice > price;
  const formattedPrice = compact ? formatPriceCompact(price) : formatPrice(price);
  const formattedComparePrice = compact && compareAtPrice ? formatPriceCompact(compareAtPrice) : formatPrice(compareAtPrice || 0);

  return (
    <div className={`flex items-baseline gap-2 min-w-0 ${className}`}>
      <span className={`font-bold text-foreground whitespace-nowrap ${
        compact ? 'text-lg' : 'text-2xl'
      }`}>
        {formattedPrice}
      </span>
      {hasDiscount && showDiscount && (
        <span className={`text-muted-foreground line-through whitespace-nowrap ${
          compact ? 'text-sm' : 'text-lg'
        }`}>
          {formattedComparePrice}
        </span>
      )}
    </div>
  );
};

export default PriceDisplay;
